if (typeof boostPFSThemeConfig !== 'undefined') {
  // Override Settings
	var boostPFSFilterConfig = {
		general: {
			limit: boostPFSConfig.custom.products_per_page,
			// Optional
			loadProductFirst: true,
			numberFilterTree: 2,
			showPlaceholderProductList: true
		},
		selector: {
			breadcrumb: '.breadcrumb',
			otpTopCartCount: '.cart-count'
		}
	};
}

(function() {
	BoostPFS.inject(this);

	// Build Product Grid Item
	ProductGridItem.prototype.compileTemplate = function(data) {
		if (!data) data = this.data;
		/*** Prepare data ***/
		var images = data.images_info;
		var soldOut = !data.available; // Check a product is out of stock
		var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
		var priceVaries = data.price_min != data.price_max; // Check a product has many prices
		// Get First Variant (selected_or_first_available_variant)
		var firstVariant = data['variants'][0];
		if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
			var paramVariant = data.variants.filter(function(e) { return e.id == Utils.getParam('variant'); });
			if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
		} else {
			for (var i = 0; i < data['variants'].length; i++) {
				if (data['variants'][i].available) {
					firstVariant = data['variants'][i];
					break;
				}
			}
		}

		/*** End Prepare data ***/

		// Get Template
		var itemHtml = boostPFSTemplate.productGridItemHtml;

		// Add a specific class for grid item
		var gridItemWidthClass = '';
		var imageSize = '600x600';
		var width = '', height = '';
		switch(boostPFSConfig.custom.products_per_row) {
			case 2:
				gridItemWidthClass = 'medium--one-half large--one-half';
				imageSize = '540x600';
				width = 540;
				height = 600;
				break;
			case 3:
				gridItemWidthClass = 'small--one-half medium--one-third large--one-third';
				imageSize = '345x550';
				width = 345;
				height = 550;
				break;
			case 4:
				gridItemWidthClass = 'small--one-half medium--one-quarter large--one-quarter';
				imageSize = '250x';
				width = 250;
				height = 225;
				break;
			case 5:
				gridItemWidthClass = 'small--one-half medium--one-fifth large--one-fifth';
				imageSize = '195x';
				width = 195;
				height = 125;
				break;
		}
		itemHtml = itemHtml.replace(/{{gridItemWidthClass}}/g, gridItemWidthClass);

		// Add soldOut class
		var soldOutClass = soldOut ? boostPFSTemplate.soldOutClass : '';
		itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);

		// Add onSale class
		var onSaleClass = onSale ? boostPFSTemplate.onSaleClass : '';
		itemHtml = itemHtml.replace(/{{onSaleClass}}/g, onSaleClass);

		// Add soldOut label
		var itemSoldOutLabelHtml = soldOut ? boostPFSTemplate.soldOutLabelHtml : '';
		itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutLabelHtml);

		// Add Thumbnail
		var itemThumbUrl = images.length > 0 ? Utils.optimizeImage(images[0]['src'], imageSize) : boostPFSConfig.general.no_image_url;
		itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);

		// Add Price
		var itemPriceHtml = '<span class="h1 medium--left">';
		if (onSale) {
			itemPriceHtml += '<span class="visually-hidden">' + boostPFSConfig.label.sale_price  + '</span>';
		} else {
			itemPriceHtml += '<span class="visually-hidden">' + boostPFSConfig.label.regular_price + '</span>';
		}
		itemPriceHtml += buildPriceHtml(data.price_min);
		if (onSale && boostPFSConfig.custom.show_compare_at_price) {
			itemPriceHtml += ' <small><s><span class="visually-hidden">' + boostPFSConfig.label.regular_price + '</span>';
			itemPriceHtml += buildPriceHtml(data.compare_at_price_min);
			itemPriceHtml += '</s></small>';
		}
		itemPriceHtml += '</span>';

		/*
if (onSale && boostPFSConfig.custom.product_show_saved_amount) {
    var class1 = boostPFSConfig.custom.show_compare_at_price ? ' medium--right ' : '';
    var class2 = boostPFSConfig.custom.product_reviews_enable ? ' has-reviews' : '';
    var savePrice = data.compare_at_price_min - data.price_min;
    savePrice = Utils.formatMoney(savePrice, Globals.moneyFormat, true);
    savePrice = savePrice
        .replace(/&nbsp;|\u00A0/g, '')
        .replace(/\s+/g, '');
    itemPriceHtml += '<span class="sale-tag' + class1 + class2 + '">';
    itemPriceHtml += boostPFSConfig.label.save_price.replace(/{{ saved_amount }}/g, savePrice);
    itemPriceHtml += '</span>';
}
*/

		if (onSale && boostPFSConfig.custom.product_show_saved_amount) {
    var class1 = boostPFSConfig.custom.show_compare_at_price ? ' medium--right ' : '';
    var class2 = boostPFSConfig.custom.product_reviews_enable ? ' has-reviews' : '';
    var savePercent = Math.round(
        (data.compare_at_price_min - data.price_min) / data.compare_at_price_min * 100
    ) + '%';
    itemPriceHtml += '<span class="sale-tag' + class1 + class2 + '">';
    itemPriceHtml += boostPFSConfig.label.save_price.replace(/{{ saved_amount }}/g, savePercent);
    itemPriceHtml += '</span>';
}
itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

		// Add Reviews
		if (typeof Integration === 'undefined' || !Integration.hascompileTemplate('reviews')) {
			var itemReviewHtml = boostPFSConfig.custom.product_reviews_enable ? '<span class="shopify-product-reviews-badge" data-id="{{itemId}}"></span><br>' : '';
			itemHtml = itemHtml.replace(/{{itemReviews}}/g, itemReviewHtml);
		}

		//Add image
		var aspect_ratio = null;
		var itemImgHtml = '';
		if (images.length > 0) {
			aspect_ratio = images[0]['width'] / images[0]['height'];
			var max_width = width;
			var max_height = height;
			if (aspect_ratio < 1) {
				max_width = height * aspect_ratio;
				if (images[0]['height'] < height) {
					max_height = images[0]['height'];
					max_width = images[0]['width'];
				} else {
					max_height = height;
				}
			} else {
				max_height = width / aspect_ratio;
				if (images[0]['width'] < width) {
					max_height = images[0]['height'];
					max_width = images[0]['width'];
				} else {
					max_width = width;
				}
			}
			itemImgHtml +=  '<div class="lazyload__image-wrapper no-js" style="max-width:' + max_width + 'px">' +
								'<div style="padding-top:' + 1 / aspect_ratio * 100 + '%;">' +
									'<img class="lazyload no-js" data-src="' + Utils.getFeaturedImage(images, '{width}x') + '" ' +
										'data-widths="[125, 180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" data-aspectratio="' + aspect_ratio +'" ' +
										'data-sizes="auto" alt="{{itemTitle}}"' +
									'/>' +
								'</div>' +
							'</div>' +
							'<noscript>' +
								'<img src="' + Utils.getFeaturedImage(images, '580x') + '"' +
									'srcset="' + Utils.getFeaturedImage(images, '580x') + ' 1x, ' + Utils.getFeaturedImage(images, '580@2x') + ' 2x" ' +
									'alt="{{itemTitle}}" style="opacity:1;"' +
								'/>' +
							'</noscript>';
		} else {
			itemImgHtml +=  '<div>' +
								'<img src="' + boostPFSConfig.general.no_image_url + '"/>' +
							'</div>';
		}
		itemHtml = itemHtml.replace(/{{itemImg}}/g, itemImgHtml);

		// Add main attribute
		itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
		itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
		itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));
        itemHtml = itemHtml.replace(/{{itemPullForce}}/g, (() => {
			// console.log(data)
			return '<span x-data-product-id="'+data.id+'" x-data-load-pull-force="1"></span>';
			if (!data.pull_force)
				return '';
			return '<div class="product-pull-force-image">' +
				'<span class="pull-force-svg--text">' + data.pull_force + '</span>' +
				'<svg class="pull-force-svg" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" enable-background="new 0 0 512 512" height="17px" id="Layer_1" version="1.1" viewBox="0 0 512 512" width="17px" xml:space="preserve">' +
				'<g>' +
				'<g>' +
				'<path d="M346.516,308.563c0-6.469-4.828-12.563-23.469-12.563H304v28h19.047 C343.938,324,346.516,315.016,346.516,308.563z" fill="#FFF"></path>' +
				'<path d="M479.703,446.234l-39.547-276.859C438.078,154.813,425.594,144,410.875,144h-81.656 c4.313-9.828,6.781-20.625,6.781-32c0-44.125-35.891-80-80-80c-44.109,0-80,35.875-80,80c0,11.375,2.469,22.172,6.781,32h-81.656    c-14.719,0-27.188,10.813-29.281,25.375L32.297,446.234c-1.203,8.483,1.328,17.078,6.938,23.563C44.845,476.282,53,480,61.578,480    h388.844c8.578,0,16.734-3.719,22.344-10.203C478.391,463.313,480.922,454.719,479.703,446.234z M240,395c0,2.75-2.25,5-5,5h-75    h-27c-2.75,0-5-2.25-5-5V277c0-2.766,2.25-5,5-5h22c2.75,0,5,2.234,5,5v91h75c2.75,0,5,2.234,5,5V395z M223.203,112    c0-18.125,14.672-32.813,32.797-32.813c18.109,0,32.797,14.688,32.797,32.813c0,18.109-14.688,32.781-32.797,32.781    C237.875,144.781,223.203,130.109,223.203,112z M336.531,400H277c-2.766,0-5-2.25-5-5V277c0-2.766,2.234-5,5-5h59.141    c33.859,0,41.547,20.438,41.547,30.75c0,3.188-0.469,6.313-1.405,9.344c-0.922,3.031-2.375,5.828-4.313,8.375    c-1.953,2.547-4.391,4.797-7.313,6.75c-2.922,1.969-6.375,3.5-10.344,4.609c3.969,0.516,7.766,1.547,11.375,3.078    c3.625,1.531,6.78,3.531,9.5,5.984c2.719,2.452,4.875,5.327,6.452,8.672c1.578,3.313,2.375,7.047,2.375,11.155    C384.016,373.781,376,400,336.531,400z" fill="#FFF"></path>' +
				'<path d="M327.828,348H304v27.984h23.828c20.891,0,23.469-8.892,23.469-15.438S346.469,348,327.828,348z" fill="#FFF"></path>' +
				'</g>' +
				'</g>' +
				'</svg>' +
				'</div>';
    })());
		return itemHtml;
	};

	ProductListItem.prototype.compileTemplate = function(data) {
		if (!data) data = this.data;
		/*** Prepare data ***/
		var images = data.images_info;
		var soldOut = !data.available; // Check a product is out of stock
		var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
		var priceVaries = data.price_min != data.price_max; // Check a product has many prices
		// Get First Variant (selected_or_first_available_variant)
		var firstVariant = data['variants'][0];
		if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
			var paramVariant = data.variants.filter(function(e) { return e.id == Utils.getParam('variant'); });
			if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
		} else {
			for (var i = 0; i < data['variants'].length; i++) {
				if (data['variants'][i].available) {
					firstVariant = data['variants'][i];
					break;
				}
			}
		}
		/*** End Prepare data ***/

		// Get Template
		var itemHtml = boostPFSTemplate.productListItemHtml;

		// Add soldOut class
		var soldOutClass = soldOut ? boostPFSTemplate.soldOutClass : '';
		itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);

		// Add onSale class
		var onSaleClass = onSale ? boostPFSTemplate.onSaleClass : '';
		itemHtml = itemHtml.replace(/{{onSaleClass}}/g, onSaleClass);

		// Add soldOut label
		var itemSoldOutLabelHtml = soldOut ? boostPFSTemplate.soldOutLabelHtml : '';
		itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutLabelHtml);

		// Add Thumbnail
		var itemThumbUrl = images.length > 0 ? Utils.optimizeImage(images[0]['src'], '600x600') : boostPFSConfig.general.no_image_url;
		itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);

		// Add Price
		var itemPriceHtml = '<span class="h1 medium--left">';
		if (onSale) {
			itemPriceHtml += '<span class="visually-hidden">' + boostPFSConfig.label.sale_price  + '</span>';
		} else {
			itemPriceHtml += '<span class="visually-hidden">' + boostPFSConfig.label.regular_price + '</span>';
		}
		itemPriceHtml += buildPriceHtml(data.price_min);
		if (onSale && boostPFSConfig.custom.show_compare_at_price) {
			itemPriceHtml += ' <small><s><span class="visually-hidden">' + boostPFSConfig.label.regular_price + '</span>';
			itemPriceHtml += buildPriceHtml(data.compare_at_price_min);
			itemPriceHtml += '</s></small>';
		}
		itemPriceHtml += '</span>';
		if (onSale && boostPFSConfig.custom.product_show_saved_amount) {
			var class1 = boostPFSConfig.custom.show_compare_at_price ? ' medium--right ' : '';
			var class2 = boostPFSConfig.custom.product_reviews_enable ? ' has-reviews' : '';
			var savePrice = data.compare_at_price_min - data.price_min;
			savePrice = Utils.formatMoney(savePrice, Globals.moneyFormat, true);
			itemPriceHtml += '<span class="sale-tag' + class1 + class2 + '">';
			itemPriceHtml += boostPFSConfig.label.save_price.replace(/{{ saved_amount }}/g, savePrice);
			itemPriceHtml += '</span>';
		}
		itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

		// Description
		var itemDescription = jQ('<p>' + data.body_html + '</p>').text();
		itemDescription = (itemDescription.split(" ")).length > 40 ? itemDescription.split(" ").splice(0, 40).join(" ") + '...' : itemDescription.split(" ").splice(0, 40).join(" ");
		itemHtml = itemHtml.replace(/{{itemDescription}}/g, itemDescription);

		// Add main attribute
		itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
		itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));
 itemHtml = itemHtml.replace(/{{itemPullForce}}/g, (() => {
        return '<span x-data-product-id="'+data.id+'" x-data-load-pull-force="1"></span>';
        if (!data.pull_force)
            return '';
        return '<div class="product-pull-force-image">' +
            '<span class="pull-force-svg--text">' + data.pull_force + '</span>' +
            '<svg class="pull-force-svg" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" enable-background="new 0 0 512 512" height="17px" id="Layer_1" version="1.1" viewBox="0 0 512 512" width="17px" xml:space="preserve">' +
            '<g>' +
            '<g>' +
            '<path d="M346.516,308.563c0-6.469-4.828-12.563-23.469-12.563H304v28h19.047 C343.938,324,346.516,315.016,346.516,308.563z" fill="#FFF"></path>' +
            '<path d="M479.703,446.234l-39.547-276.859C438.078,154.813,425.594,144,410.875,144h-81.656 c4.313-9.828,6.781-20.625,6.781-32c0-44.125-35.891-80-80-80c-44.109,0-80,35.875-80,80c0,11.375,2.469,22.172,6.781,32h-81.656    c-14.719,0-27.188,10.813-29.281,25.375L32.297,446.234c-1.203,8.483,1.328,17.078,6.938,23.563C44.845,476.282,53,480,61.578,480    h388.844c8.578,0,16.734-3.719,22.344-10.203C478.391,463.313,480.922,454.719,479.703,446.234z M240,395c0,2.75-2.25,5-5,5h-75    h-27c-2.75,0-5-2.25-5-5V277c0-2.766,2.25-5,5-5h22c2.75,0,5,2.234,5,5v91h75c2.75,0,5,2.234,5,5V395z M223.203,112    c0-18.125,14.672-32.813,32.797-32.813c18.109,0,32.797,14.688,32.797,32.813c0,18.109-14.688,32.781-32.797,32.781    C237.875,144.781,223.203,130.109,223.203,112z M336.531,400H277c-2.766,0-5-2.25-5-5V277c0-2.766,2.234-5,5-5h59.141    c33.859,0,41.547,20.438,41.547,30.75c0,3.188-0.469,6.313-1.405,9.344c-0.922,3.031-2.375,5.828-4.313,8.375    c-1.953,2.547-4.391,4.797-7.313,6.75c-2.922,1.969-6.375,3.5-10.344,4.609c3.969,0.516,7.766,1.547,11.375,3.078    c3.625,1.531,6.78,3.531,9.5,5.984c2.719,2.452,4.875,5.327,6.452,8.672c1.578,3.313,2.375,7.047,2.375,11.155    C384.016,373.781,376,400,336.531,400z" fill="#FFF"></path>' +
            '<path d="M327.828,348H304v27.984h23.828c20.891,0,23.469-8.892,23.469-15.438S346.469,348,327.828,348z" fill="#FFF"></path>' +
            '</g>' +
            '</g>' +
            '</svg>' +
            '</div>';
    })());
		return itemHtml;
	};

	function buildPriceHtml(price) {
		var customPrice = Utils.formatMoney(price);
		if (!(Globals.moneyFormat.indexOf('money') > -1 || Globals.moneyFormat.indexOf('.') > -1)) {
			if (boostPFSConfig.custom.superscript_decimals) {
				if (Globals.moneyFormat.indexOf('{{amount}}') !== -1 || Globals.moneyFormat.indexOf('{{ amount }}') !== -1) {
					customPrice = customPrice.replace('.', '<sup>') + '</sup>';
				} else if (Globals.moneyFormat.indexOf('{{amount_with_comma_separator}}') !== -1 || Globals.moneyFormat.indexOf('{{ amount_with_comma_separator }}') !== -1) {
					customPrice = customPrice.replace(',', '<sup>') + '</sup>';
				}
			}
		}
		var html = '<small aria-hidden="true">' + customPrice + '</small>';
		html += '<span class="visually-hidden">' + Utils.formatMoney(price) + '</span>';
		return html;
	}

	// Build Pagination
	ProductPaginationDefault.prototype.compileTemplate = function(totalProduct) {
		if (!totalProduct) totalProduct = this.totalProduct;
		// Get page info
		var currentPage = parseInt(Globals.queryParams.page);
		var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);

		if (totalPage > 1) {
			var paginationHtml = boostPFSTemplate.paginateHtml;

			// Build Previous
			var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : boostPFSTemplate.previousDisabledHtml;
			previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
			paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

			// Build Next
			var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml :  boostPFSTemplate.nextDisabledHtml;
			nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
			paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

			// Create page items array
			var beforeCurrentPageArr = [];
			for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
				beforeCurrentPageArr.unshift(iBefore);
			}
			if (currentPage - 4 > 0) {
				beforeCurrentPageArr.unshift('...');
			}
			if (currentPage - 4 >= 0) {
				beforeCurrentPageArr.unshift(1);
			}
			beforeCurrentPageArr.push(currentPage);

			var afterCurrentPageArr = [];
			for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
				afterCurrentPageArr.push(iAfter);
			}
			if (currentPage + 3 < totalPage) {
				afterCurrentPageArr.push('...');
			}
			if (currentPage + 3 <= totalPage) {
				afterCurrentPageArr.push(totalPage);
			}

			// Build page items
			var pageItemsHtml = '';
			var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
			for (var iPage = 0; iPage < pageArr.length; iPage++) {
				if (pageArr[iPage] == '...') {
					pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
				} else {
					pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
				}
				pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
				pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
			}
			paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);

			return paginationHtml;
		}

		return '';
	};

	// Build Sorting
	ProductSorting.prototype.compileTemplate = function() {
		var html = '';
		if (boostPFSTemplate.hasOwnProperty('sortingHtml')) {
			var sortingArr = Utils.getSortingList();
			if (sortingArr) {
				// Build content
				var sortingItemsHtml = '';
				for (var k in sortingArr) {
					sortingItemsHtml += '<option value="' + k +'">' + sortingArr[k] + '</option>';
				}
				html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
			}
		}
		return html;
	};

	// Build Display type
	ProductDisplayType.prototype.compileTemplate = function() {
		var itemHtml = boostPFSTemplate.displayTypeHtml;
		itemHtml = itemHtml.replace(/{{gridUrl}}/g, Utils.buildToolbarLink('display', 'list', 'grid'));
		itemHtml = itemHtml.replace(/{{listUrl}}/g, Utils.buildToolbarLink('display', 'grid', 'list'));
		itemHtml = itemHtml.replace(/{{gridView}}/g, Labels.gridView);
		itemHtml = itemHtml.replace(/{{listView}}/g, Labels.listView);

		return itemHtml;
	};

	Breadcrumb.prototype.compileTemplate = function (colData) {
		if (!colData) colData = this.collectionData;
		var breadcrumbHtml = '';
		if (boostPFSTemplate.hasOwnProperty('breadcrumbHtml')) {
			breadcrumbHtml = boostPFSTemplate.breadcrumbHtml;
			var colInfo = colData.collection;
			var currentCollectionHtml = '';
			if (Array.isArray(boostPFSConfig.general.current_tags) && boostPFSConfig.general.current_tags.length > 0) {
				currentCollectionHtml += ' <a href="/collections/' + colInfo.handle + '">' + colInfo.title + '</a>';
				currentCollectionHtml += ' <span class="divider" aria-hidden="true">&rsaquo;</span>'
				currentCollectionHtml += ' <span>' + current_tags.join(' + ') + '</span>';
			} else {
				currentCollectionHtml += ' <span>' + colInfo.title + '</span>';
			}
			breadcrumbHtml = breadcrumbHtml.replace(/{{currentCollection}}/g, currentCollectionHtml);
		}

		return breadcrumbHtml;
	}

	// Add additional feature for product list, used commonly in customizing product list
	ProductList.prototype.afterRender = function (data) {};

	// Build Additional Elements
	FilterResult.prototype.afterRender = function (data) {
		if (!data) data = this.data;
		jQ(document).ready(function() {
			if (typeof theme !== 'undefined' && theme.hasOwnProperty('Sections')) {
				var sections = new theme.Sections();
				sections.register('collection-template', theme.Collection);
			}
		});

		if (window.SPR) {
			SPR.initDomEls();
			SPR.loadBadges();
		}
	};
})();
